import { render } from "./DemoCustomMenuItem.vue?vue&type=template&id=a87171f6&scoped=true"
import script from "./DemoCustomMenuItem.vue?vue&type=script&lang=js"
export * from "./DemoCustomMenuItem.vue?vue&type=script&lang=js"

import "./DemoCustomMenuItem.vue?vue&type=style&index=0&id=a87171f6&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87171f6"]])

export default __exports__